function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import React from 'react';
import './notification-summary-card.scss';
import numeral from 'numeral';
import moment from 'moment-timezone';
import { Select } from 'antd';
import '@ant-design/compatible/assets/index.css';
import PreviewSDK, { Browser, Platform, PreviewState } from '@pushly/cuttlefish';
import Well from '../well/well';
import { StatusType } from '../../enums/status-type';
import { NotificationDeliveryWindow } from '../../enums/notification-delivery-window';
import { NotificationDeliveryType } from '../../enums/notification-delivery-type';
import { numberWithCommas } from '../../utils/numeral';
import { DATE_TIME_FORMAT_WITH_TZ, DATE_TIME_FORMAT_WITHOUT_TZ } from '../../constants';
import { buildPreviewOptions, isNotificationScheduleStzDeliveryInProgress, isNotificationScheduleUsingStzDelivery } from '../../utils/notifications';
import { DeliveryChannel } from '../../interfaces/notification-channels';
import titleCase from 'title-case';

var NotificationSummaryCard = /*#__PURE__*/function (_React$Component) {
  _inherits(NotificationSummaryCard, _React$Component);

  var _super = _createSuper(NotificationSummaryCard);

  function NotificationSummaryCard() {
    var _this$props$initialPl;

    var _this;

    _classCallCheck(this, NotificationSummaryCard);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      previewPlatform: (_this$props$initialPl = _this.props.initialPlatform) !== null && _this$props$initialPl !== void 0 ? _this$props$initialPl : Platform.ANDROID,
      previewState: PreviewState.EXPANDED
    };

    _this.setSelectedPreviewPlatform = function (value) {
      var _this$props$onPlatfor, _this$props;

      _this.setState({
        previewPlatform: value
      });

      (_this$props$onPlatfor = (_this$props = _this.props).onPlatformChange) === null || _this$props$onPlatfor === void 0 ? void 0 : _this$props$onPlatfor.call(_this$props, value);
    };

    _this.setPreviewState = function (value) {
      _this.setState({
        previewState: value
      });
    };

    _this.buildPreviewConfig = function () {
      var _this$props$domain$na, _this$props$domain;

      var notification = _this.props.notification;
      var actions;

      if (!!notification.actions) {
        actions = notification.actions.map(function (a) {
          return {
            title: a.label
          };
        });
      }

      return {
        animated: false,
        browser: Browser.CHROME,
        platform: _this.state.previewPlatform,
        previewState: _this.state.previewState,
        state: _this.state.previewState,
        notification: {
          title: notification.title,
          body: notification.body,
          domain: (_this$props$domain$na = (_this$props$domain = _this.props.domain) === null || _this$props$domain === void 0 ? void 0 : _this$props$domain.name) !== null && _this$props$domain$na !== void 0 ? _this$props$domain$na : 'pushly.com',
          icon: notification.icon,
          image: notification.image,
          badge: notification.badge,
          subtitle: notification.subtitle,
          actions: actions
        }
      };
    };

    _this.handleTitleClick = function (ev) {
      var _this$props$onTitleCl, _this$props2;

      if (!_this.props.onTitleClick) {
        ev.preventDefault();
      }

      (_this$props$onTitleCl = (_this$props2 = _this.props).onTitleClick) === null || _this$props$onTitleCl === void 0 ? void 0 : _this$props$onTitleCl.call(_this$props2, ev);
    };

    return _this;
  }

  _createClass(NotificationSummaryCard, [{
    key: "render",
    value: function render() {
      var _notification$keyword;

      var notification = this.props.notification;
      var abTest = notification.abTest;
      return /*#__PURE__*/React.createElement(Well, {
        className: this.getClassNames(),
        loading: this.props.loading,
        hideHeader: true,
        hideFooter: this.props.hideFooter
      }, this.props.title && /*#__PURE__*/React.createElement("a", {
        className: "summary-title",
        onClick: this.handleTitleClick,
        href: this.props.titleUrl
      }, this.props.title, this.props.showWeight && !!(abTest !== null && abTest !== void 0 && abTest.weight) && /*#__PURE__*/React.createElement("span", {
        className: "ab-test-weight"
      }, abTest.weight)), !this.props.hideStats && /*#__PURE__*/React.createElement("div", {
        className: "summary-header"
      }, !this.props.hideStatus && /*#__PURE__*/React.createElement("div", {
        className: "summary-status"
      }, /*#__PURE__*/React.createElement("div", null, "Status"), /*#__PURE__*/React.createElement("span", {
        className: "stat"
      }, this.renderStatus())), /*#__PURE__*/React.createElement("div", {
        className: "summary-imps"
      }, /*#__PURE__*/React.createElement("div", null, "Impressions"), /*#__PURE__*/React.createElement("span", {
        className: "stat"
      }, this.renderImpressions())), /*#__PURE__*/React.createElement("div", {
        className: "summary-ctr"
      }, /*#__PURE__*/React.createElement("div", null, "Clicks (CTR)"), /*#__PURE__*/React.createElement("span", {
        className: "stat"
      }, this.renderCTR()))), /*#__PURE__*/React.createElement("div", {
        className: "summary-details"
      }, this.renderPreview(), this.props.showScheduleDetails && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "summary-content-div"
      }), /*#__PURE__*/React.createElement("div", {
        className: "summary-content-delivery"
      }, /*#__PURE__*/React.createElement("div", {
        className: "summary-delivery-time"
      }, /*#__PURE__*/React.createElement("span", null, "Delivery Time"), this.getSendDateDisplay()), /*#__PURE__*/React.createElement("div", {
        className: "summary-delivery-strategy"
      }, /*#__PURE__*/React.createElement("span", null, "Delivery Strategy"), this.getSendStrategy()))), /*#__PURE__*/React.createElement("div", {
        className: "summary-content-div"
      }), /*#__PURE__*/React.createElement("div", {
        className: "summary-landing-url"
      }, /*#__PURE__*/React.createElement("span", null, "Landing URL"), /*#__PURE__*/React.createElement("div", {
        className: "link-wrapper"
      }, !!notification.landingUrl ? /*#__PURE__*/React.createElement("a", {
        href: notification.landingUrl,
        target: "_blank"
      }, notification.landingUrl) : 'No destination')), notification.altNativeUrl && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "summary-content-div"
      }), /*#__PURE__*/React.createElement("div", {
        className: "summary-native-landing-url"
      }, /*#__PURE__*/React.createElement("span", null, "Alt Native Landing Url"), notification.altNativeUrl)), /*#__PURE__*/React.createElement("div", {
        className: "summary-content-div"
      }), /*#__PURE__*/React.createElement("div", {
        className: "summary-keywords"
      }, /*#__PURE__*/React.createElement("span", null, "Keywords"), (_notification$keyword = notification.keywords) !== null && _notification$keyword !== void 0 && _notification$keyword.length ? notification.keywords.join(', ') : 'No keywords')));
    }
  }, {
    key: "notificationIsCompleted",
    get: function get() {
      return this.props.notification.statusId !== undefined && [StatusType.COMPLETED, StatusType.COMPLETED_WITH_FAILURES].includes(this.props.notification.statusId);
    }
  }, {
    key: "notificationIsNonCampaignStzInProgress",
    get: function get() {
      var notification = this.props.notification;
      return !this.props.isCampaignNotif && !!(notification !== null && notification !== void 0 && notification.schedule) && !this.notificationIsCompleted && !isNotificationScheduleStzDeliveryInProgress(notification.schedule, notification.statusId);
    }
  }, {
    key: "mode",
    get: function get() {
      return !this.props.mode || this.props.mode === 'default' ? 'light' : this.props.mode;
    }
  }, {
    key: "renderPreview",
    value: function renderPreview() {
      var _optsHash, _this$props$channels;

      var optsHash = (_optsHash = {}, _defineProperty(_optsHash, DeliveryChannel.WEB, false), _defineProperty(_optsHash, DeliveryChannel.NATIVE_ANDROID, false), _defineProperty(_optsHash, DeliveryChannel.NATIVE_IOS, false), _optsHash);
      (_this$props$channels = this.props.channels) === null || _this$props$channels === void 0 ? void 0 : _this$props$channels.map(function (ch) {
        return optsHash[ch] = true;
      });
      var platformOptions = buildPreviewOptions(optsHash);
      var previewStateOptions = Object.keys(PreviewState).filter(function (key) {
        return typeof key === 'string';
      }).map(function (key) {
        return {
          value: PreviewState[key],
          label: titleCase(PreviewState[key])
        };
      });
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "cuttlefish-preview-selectors"
      }, /*#__PURE__*/React.createElement(Select, {
        className: "preview-platform-selector",
        options: platformOptions,
        value: this.state.previewPlatform,
        onChange: this.setSelectedPreviewPlatform,
        dropdownMatchSelectWidth: false
      }), /*#__PURE__*/React.createElement(Select, {
        className: "preview-state-selector",
        options: previewStateOptions,
        value: this.state.previewState,
        onChange: this.setPreviewState,
        dropdownMatchSelectWidth: false
      })), /*#__PURE__*/React.createElement("div", {
        className: "cuttlefish-preview-wrapper"
      }, /*#__PURE__*/React.createElement(PreviewSDK.NotificationPreview, {
        config: this.buildPreviewConfig()
      })));
    }
  }, {
    key: "renderStatus",
    value: function renderStatus() {
      var _schedule$deliverySpe;

      var notification = this.props.notification;
      var schedule = notification.schedule;
      var origStatus = notification.statusId;
      var status = 'Scheduled';
      var isFailed = origStatus === StatusType.FAILED;
      var isCancelled = origStatus === StatusType.CANCELLED || origStatus === StatusType.CANCELLING;
      var isStarted = !!(schedule !== null && schedule !== void 0 && schedule.startedDateUtc) || (schedule === null || schedule === void 0 ? void 0 : (_schedule$deliverySpe = schedule.deliverySpec) === null || _schedule$deliverySpe === void 0 ? void 0 : _schedule$deliverySpe.type) === NotificationDeliveryType.IMMEDIATE;
      var isCompleted = !!(schedule !== null && schedule !== void 0 && schedule.completedDateUtc) && origStatus !== StatusType.DELIVERING;

      if (isFailed) {
        status = 'Failed';
      } else if (isCancelled) {
        status = 'Cancelled';
      } else if (isCompleted) {
        var _schedule$deliverySpe2;

        status = (schedule === null || schedule === void 0 ? void 0 : (_schedule$deliverySpe2 = schedule.deliverySpec) === null || _schedule$deliverySpe2 === void 0 ? void 0 : _schedule$deliverySpe2.window) === NotificationDeliveryWindow.HOLD_OUT ? 'Hold Out' : 'Delivered';
      } else if (isStarted) {
        status = 'Delivering';
      }

      return status;
    }
  }, {
    key: "renderImpressions",
    value: function renderImpressions() {
      var _this$props$stats;

      if (this.notificationIsNonCampaignStzInProgress) {
        return '--';
      }

      if (((_this$props$stats = this.props.stats) === null || _this$props$stats === void 0 ? void 0 : _this$props$stats.impressions) === undefined) {
        return '0';
      }

      return numeral(this.props.stats.impressions).format('O,O');
    }
  }, {
    key: "renderCTR",
    value: function renderCTR() {
      var _stats$clicks;

      var stats = this.props.stats;

      if ((stats === null || stats === void 0 ? void 0 : stats.impressions) === undefined || this.notificationIsNonCampaignStzInProgress) {
        return '--';
      }

      var ctrValue = stats.clicks && stats.impressions ? numeral(stats.clicks / stats.impressions).format('0.00%') : '--';
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "click-value"
      }, numberWithCommas((_stats$clicks = stats.clicks) !== null && _stats$clicks !== void 0 ? _stats$clicks : 0)), /*#__PURE__*/React.createElement("span", {
        className: "ctr-value"
      }, "(", ctrValue, ")"));
    }
  }, {
    key: "getClassNames",
    value: function getClassNames() {
      var _this$props$notificat;

      var classNames = ['thin', 'notification-summary-card', "mode-".concat(this.mode)];

      if (this.props.className) {
        classNames.push(this.props.className);
      }

      if (!this.props.notification.image) {
        classNames.push('no-image');
      }

      if (this.props.compactPreview) {
        classNames.push('compact-preview');
      }

      if (!this.props.title) {
        classNames.push('no-name');
      }

      if (!this.props.hideStatus) {
        classNames.push('no-status');
      }

      if ((_this$props$notificat = this.props.notification.abTest) !== null && _this$props$notificat !== void 0 && _this$props$notificat.winner) {
        classNames.push('test-winner');
      }

      if (!!this.props.showWeight) {
        classNames.push('with-weight');
      }

      return classNames.join(' ');
    }
  }, {
    key: "getSendDateDisplay",
    value: function getSendDateDisplay() {
      var _schedule$deliverySpe3, _ref, _schedule$deliverySpe4, _this$props$domain2;

      var notification = this.props.notification;
      var schedule = notification.schedule;

      if (!(schedule !== null && schedule !== void 0 && (_schedule$deliverySpe3 = schedule.deliverySpec) !== null && _schedule$deliverySpe3 !== void 0 && _schedule$deliverySpe3.sendDateUtc)) {
        return '--';
      }

      var displayTZ = (_ref = (_schedule$deliverySpe4 = schedule.deliverySpec.timezone) !== null && _schedule$deliverySpe4 !== void 0 ? _schedule$deliverySpe4 : (_this$props$domain2 = this.props.domain) === null || _this$props$domain2 === void 0 ? void 0 : _this$props$domain2.timezone) !== null && _ref !== void 0 ? _ref : 'UTC';
      var isNotificationUsingStz = isNotificationScheduleUsingStzDelivery(schedule);
      var dateFormat = isNotificationUsingStz ? "".concat(DATE_TIME_FORMAT_WITHOUT_TZ, " [STZ]") : DATE_TIME_FORMAT_WITH_TZ;
      var startDate = moment.tz(schedule.deliverySpec.sendDateUtc, displayTZ);
      return startDate.format(dateFormat);
    }
  }, {
    key: "getSendStrategy",
    value: function getSendStrategy() {
      var _this$props$notificat2;

      var strategyStr = '';
      var deliverySpec = (_this$props$notificat2 = this.props.notification.schedule) === null || _this$props$notificat2 === void 0 ? void 0 : _this$props$notificat2.deliverySpec;

      if (!deliverySpec) {
        return strategyStr;
      }

      var type = deliverySpec.type;
      var window = deliverySpec.window;

      if (window === NotificationDeliveryWindow.HOLD_OUT) {
        strategyStr = 'Hold Out';
      } else if (window === NotificationDeliveryWindow.INFORMED) {
        strategyStr = 'Informed';
      } else if (type === NotificationDeliveryType.IMMEDIATE) {
        strategyStr = 'Immediate';
      } else if (window === NotificationDeliveryWindow.STANDARD) {
        strategyStr = 'Fixed';
      } else if (window === NotificationDeliveryWindow.TIMEZONE) {
        strategyStr = 'Subscriber Time Zone';
      }

      return strategyStr;
    }
  }]);

  return NotificationSummaryCard;
}(React.Component);

export default NotificationSummaryCard;